import React from 'react';

type AccessibleEmojiProps = {
  symbol: string | React.ReactNode;
  label: string;
  className?: string;
};

export default function AccessibleEmoji({ symbol, label, className }: AccessibleEmojiProps) {
  return (
    <span role="img" aria-label={label} className={className}>
      {symbol}
    </span>
  );
}


